export default "__VITE_ASSET__CNCMZnLk__"